/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Pll_New_Material_Autofill_ShortInputs */

const vi_pll_new_material_autofill_short = /** @type {(inputs: Pll_New_Material_Autofill_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kho không đủ vật tư theo định mức, còn thiếu: ${i?.list}`)
};

/**

* @param {Pll_New_Material_Autofill_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_material_autofill_short = /** @type {((inputs: Pll_New_Material_Autofill_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Material_Autofill_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_material_autofill_short(inputs)
});